import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import type { ReceiptId, StoreId } from "@KassaroAB/shared/types/ids";
import {
  getReceiptApi,
  getReceiptsApi,
  type ReceiptFilters,
} from "../api/receiptsApi";

export const useGetInfiniteReceiptsQuery = (
  storeId: StoreId | null,
  filters?: ReceiptFilters,
) => {
  return useInfiniteQuery({
    queryKey: ["stores", storeId, "receipts", filters],
    queryFn: ({ pageParam }: { pageParam: ReceiptId | null }) =>
      getReceiptsApi(storeId!, pageParam, filters),
    initialPageParam: null as ReceiptId | null,
    getNextPageParam: (lastPage) => {
      if (lastPage.length < 25) return undefined;
      return lastPage.length > 0 ? lastPage[lastPage.length - 1].id : undefined;
    },
    enabled: !!storeId,
  });
};

export const useGetReceiptQuery = (
  storeId: StoreId | null,
  receiptId: ReceiptId | null,
) => {
  return useQuery({
    queryKey: ["stores", storeId, "receipts", receiptId],
    queryFn: () => getReceiptApi(storeId!, receiptId!),
    enabled: !!storeId && !!receiptId,
  });
};
